export default __webpack_public_path__ + "static/media/C240251.90f6b07e.jpg";